export default __webpack_public_path__ + "static/media/hammer.0452c6a9.svg";